// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  worldId: __t.u64(),
  timeMode: __t.string(),
  fixedTimeOfDay: __t.f32(),
  cycleSeconds: __t.u32(),
  weatherMode: __t.string(),
  weather: __t.string(),
  fogMul: __t.f32(),
  fogColorHex: __t.string(),
  sunMul: __t.f32(),
  ambientMul: __t.f32(),
  sunTintHex: __t.string(),
  ambienceKey: __t.string(),
  ambienceGain: __t.f32(),
};
